import React from 'react';
import BoardList from './BoardList';

export default function NoticeList() {
  return (
    <BoardList
      fixedType="notice"
      showTabs={false}
      title="공지사항"
      subtitle="와우크루즈의 새로운 소식을 확인해 주세요."
      basePath="/notice"
    />
  );
}
